import React from 'react';
import withTheme from '@material-ui/core/styles/withTheme';
import IconButton from '@material-ui/core/IconButton';
import { PlusIcon, TimesIcon } from '../../icons';

const ImageUploader = ({
    id,
    image,
    multiple = false,
    className = '',
    style = {},
    theme,
    uploadImage,
    removeImage
}) => {
    return (
        <label
            htmlFor={id}
            className={`image-uploader ${className} ${!uploadImage ? 'disabled' : ''}`}
            style={style}
        >
            <input
                id={id}
                type="file"
                accept="images/*"
                multiple={multiple}
                disabled={!uploadImage}
                onChange={uploadImage}
            />
            {image ? (
                <div className="image-uploader__has-image">
                    <img src={image} alt="" />
                    <IconButton
                        onClick={event => {
                            event.preventDefault();
                            removeImage();
                        }}
                        className="image-uploader__has-image-delete"
                    >
                        <TimesIcon color={theme.palette.secondary.main} />
                    </IconButton>
                </div>
            ) : (
                <div
                    className="image-uploader__no-image"
                    style={{ borderColor: theme.palette.secondary.main }}
                >
                    <PlusIcon
                        className="image-uploader__no-image-icon"
                        color={theme.palette.secondary.main}
                    />
                    <div
                        className="image-uploader__no-image-label"
                        style={{ color: theme.palette.secondary.main }}
                    >
                        Add image
                    </div>
                </div>
            )}
        </label>
    );
};

export default withTheme(ImageUploader);
